const BAR = {
  blocked: "bg-red-500",
  warning: "bg-amber-500",
  ok: "bg-blue-600",
};

export const UsageBars = ({ usage, testid = "usage-bars" }) => {
  if (!usage) return <p className="text-[12px] text-slate-500">Gebruik laden…</p>;

  return (
    <div className="space-y-3.5" data-testid={testid}>
      {usage.unlimited && (
        <p className="text-[12px] text-slate-500" data-testid="usage-unlimited">
          Onbeperkt gebruik — dit is het ImDash-masteraccount.
        </p>
      )}
      {(usage.metrics || []).map((m) => {
        const tone = m.blocked ? "blocked" : m.warning ? "warning" : "ok";
        const filled = m.limit ? Math.min(100, Math.round((m.used / m.limit) * 100)) : 100;
        return (
          <div key={m.metric} data-testid={`usage-metric-${m.metric}`}>
            <div className="flex items-baseline justify-between gap-3 text-[12px]">
              <span className="text-slate-700">{m.label}</span>
              <span className="mono text-slate-600">
                {m.used} / {m.limit == null ? "onbeperkt" : m.limit}
              </span>
            </div>
            <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
              <div
                className={`h-full rounded-full transition-[width] duration-500 ${BAR[tone]}`}
                style={{ width: `${filled}%`, opacity: m.limit == null ? 0.25 : 1 }}
              />
            </div>
            {m.extra_granted > 0 && (
              <div className="mt-0.5 text-[11px] text-slate-500">
                inclusief {m.extra_granted} extra toegekend deze maand
              </div>
            )}
            {m.blocked && (
              <div className="mt-0.5 text-[11px] font-semibold text-red-700">
                Limiet bereikt — geblokkeerd tot volgende maand of tot extra ruimte is toegekend.
              </div>
            )}
            {m.warning && (
              <div className="mt-0.5 text-[11px] text-amber-700">
                Bijna op: {m.used_pct}% van de maandlimiet gebruikt.
              </div>
            )}
          </div>
        );
      })}
      <p className="text-[11px] text-slate-400">Kalendermaand {usage.period}</p>
    </div>
  );
};
